<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <!-- breadcrumbs -->
            <fragment>
                <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            </fragment>
            <!-- //breadcrumbs -->
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <!-- //contents_head -->

            <!-- srchTop_wrap -->
            <div class="srchTop_wrap">
                <article class="srch_basic">
                    <div class="srch_grup">
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.INQUIRY') }}</li>
                            <li data-input-type="select" class="w100-150">
                                <fieldset class="ui_fieldset set_2">
                                    <div>
                                        <select class="slt_white w100" v-model="inquiry1Code" @change="inquiryList(2)">
                                            <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option
                                                v-for="item in inquiry1CodeList"
                                                :key="pageName + item.CD"
                                                :value="item.CD"
                                            >
                                                {{ item.CD_NAME }}
                                            </option>
                                        </select>
                                    </div>
                                    <div>
                                        <select class="slt_white w100" v-model="inquiry2Code">
                                            <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option
                                                v-for="item in inquiry2CodeList"
                                                :key="pageName + item.CD"
                                                :value="item.CD"
                                            >
                                                {{ item.CD_NAME }}
                                            </option>
                                        </select>
                                    </div>
                                </fieldset>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.ADMIN.PROCESSIN.LEVEL') }}</li>
                            <li data-input-type="select" class="w100-150">
                                <select class="slt_white w100" v-model="searchRegDeptLevelCd">
                                    <option
                                        v-for="item in searchRegDeptLevelList"
                                        :key="pageName + item.code"
                                        :value="item.code"
                                    >
                                        {{ item.codeName }}
                                    </option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.ADMIN.KIP.CHARGE') }}</li>
                            <li data-input-type="select" class="w100-150">
                                <select class="slt_white w100" v-model="kpi_charge">
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option v-for="item in kpiChargeList" :key="pageName + item.CD" :value="item.CD">
                                        {{ item.CD_NAME }}
                                    </option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.FAST.ADVANCED.MODEL') }}</li>
                            <li data-input-type="input" class="w100-150">
                                <label class="serach-wrap">
                                    <input
                                        type="text"
                                        class="text_input w100"
                                        :placeholder="$t('BUTTON.GLOBAL.SEARCH')"
                                        v-model="modelNm"
                                        disabled
                                    />
                                    <a class="in_btn_search" @click="searchModelPopup()">
                                        <i class="ico_input_serach"></i>
                                        <span class="sr_only"></span>
                                    </a>
                                </label>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.CATEGORY') }}</li>
                            <li data-input-type="select" class="w100-150">
                                <fieldset class="ui_fieldset set_3">
                                    <div>
                                        <select
                                            class="slt_white w100p"
                                            v-model="category1Code"
                                            @change="categoryList(2)"
                                            :disabled="categoryDisabled"
                                        >
                                            <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option
                                                v-for="item in category1CodeList"
                                                :key="pageName + item.code"
                                                :value="item.code"
                                            >
                                                {{ item.codeName }}
                                            </option>
                                        </select>
                                    </div>
                                    <div>
                                        <select
                                            class="slt_white w100p"
                                            v-model="category2Code"
                                            @change="categoryList(3)"
                                        >
                                            <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option
                                                v-for="item in category2CodeList"
                                                :key="pageName + item.code"
                                                :value="item.code"
                                            >
                                                {{ item.codeName }}
                                            </option>
                                        </select>
                                    </div>
                                    <div>
                                        <select class="slt_white w100p" v-model="category3Code">
                                            <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option
                                                v-for="item in category3CodeList"
                                                :key="pageName + item.code"
                                                :value="item.code"
                                            >
                                                {{ item.codeName }}
                                            </option>
                                        </select>
                                    </div>
                                </fieldset>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.DEPARTMENT') }}</li>
                            <li data-input-type="select" class="w100-150">
                                <select
                                    class="slt_white w100"
                                    v-model="gbm_cd"
                                    v-if="['4'].includes(searchRegDeptLevelCd)"
                                >
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option v-for="item in gbmCdList" :key="pageName + item.CD" :value="item.CD">
                                        {{ item.CD_NAME }}
                                    </option>
                                </select>
                                <select
                                    class="slt_white w100"
                                    v-model="rhqCode"
                                    v-if="['3'].includes(searchRegDeptLevelCd)"
                                    @change="categoryList(5)"
                                >
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option v-for="item in rhqCodeList" :key="pageName + item.code" :value="item.code">
                                        {{ item.codeName }}
                                    </option>
                                </select>
                                <fieldset class="ui_fieldset set_2" v-if="['1', '2'].includes(searchRegDeptLevelCd)">
                                    <div>
                                        <select class="slt_white w100" v-model="rhqCode" @change="categoryList(5)">
                                            <option
                                                v-for="item in rhqCodeList"
                                                :key="pageName + item.code"
                                                :value="item.code"
                                            >
                                                {{ item.codeName }}
                                            </option>
                                        </select>
                                    </div>
                                    <div>
                                        <select class="slt_white w100" v-model="subsidiary">
                                            <option
                                                v-for="item in subsidiaryList"
                                                :key="pageName + item.code"
                                                :value="item.code"
                                            >
                                                {{ item.codeName }}
                                            </option>
                                        </select>
                                    </div>
                                </fieldset>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.DELAY.PERIOD') }}</li>
                            <li data-input-type="input" class="w100-150">
                                <span class="clearable w33_3">
                                    <input
                                        type="text"
                                        class="text_input w100"
                                        placeholder="days"
                                        v-model="searchDelayPeriod"
                                        @keyup.enter.stop="onSearch(1)"
                                        v-clearable
                                    />
                                </span>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.STATUS') }}</li>
                            <li data-input-type="select" class="w100-150">
                                <select class="slt_white w100" v-model="searchStatus">
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option
                                        v-for="item in searchStatusList"
                                        :key="pageName + item.code"
                                        :value="item.code"
                                    >
                                        {{ item.codeName }}
                                    </option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.QUESTION.ID') }}({{ $t('BUTTON.GLOBAL.NEW') }})</li>
                            <li data-input-type="input" class="w100-150">
                                <span class="clearable">
                                    <input
                                        type="text"
                                        class="text_input w100"
                                        v-model="questionId"
                                        @keyup.enter.stop="onSearch(1)"
                                        v-clearable
                                    />
                                </span>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.DATE') }}</li>
                            <li data-input-type="date" class="w100-150">
                                <fieldset class="ui_fieldset">
                                    <span class="date-wrap">
                                        <label>
                                            <input
                                                id="frDate"
                                                type="text"
                                                class="date_input w100p"
                                                placeholder="MM.DD.YYYY"
                                                readonly maxlength="20"
                                            />
                                            <a href="javascript:" class="in_btn" id="icoFrDate">
                                                <i class="ico_date"></i>
                                                <span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span>
                                            </a>
                                        </label>
                                        <div class="fr_datepicker" id="fr-picker-container" />
                                    </span>
                                    <em class="txt_space"></em>
                                    <span class="date-wrap">
                                        <label>
                                            <input
                                                id="toDate"
                                                type="text"
                                                class="date_input w100p"
                                                placeholder="MM.DD.YYYY"
                                                readonly maxlength="20"
                                            />
                                            <a href="javascript:" class="in_btn" id="icoToDate">
                                                <i class="ico_date"></i>
                                                <span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span>
                                            </a>
                                        </label>
                                        <div class="to_datepicker" id="to-picker-container" />
                                    </span>
                                </fieldset>
                            </li>
                        </ul>
                    </div>
                    <div class="srch_grupR">
                        <span class="btn">
                            <a href="javascript:" class="btn_srch" @click="onSearch(1)">{{
                                $t('BUTTON.GLOBAL.SEARCH')
                            }}</a>
                        </span>
                    </div>
                </article>
            </div>
            <!-- Grid -->
            <div class="grid_wrap">
                <!-- Count -->
                <div class="grid_total">
                    {{ $t('TITLE.TOTAL.COUNT') }} <em>{{ totalCount }}</em>
                </div>
                <div class="btn_wrap">
                    <a href="javascript:" class="btn_white" @click="onExcel('ALL')">
                        {{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}
                    </a>
                    <a href="javascript:" class="btn_white" @click="onExcel('ANSWER')">
                        {{ $t('FIELD.GLOBAL.EXCELWITHANSWER') }}
                    </a>
                </div>
                <!-- Grid -->
                <toast-grid
                    :gridId="gridId"
                    :columns="columns"
                    :data="gridData"
                    :options="options"
                    :ref="gridId"
                    :key="gridKey"
                    :isTotalCount="false"
                    :click="contentClick"
                />
            </div>
            <div class="paginate">
                <sdl-pagination
                    align="center"
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="nRecordsPerPage"
                    @change="onSearch"
                />
            </div>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import moment from 'moment';
import SDLUtil from '@/utils/SDLUtil';
import { mapActions, mapGetters } from 'vuex';

import ToastGrid from '~c/ToastGrid';
import SDLPagination from '~~c/control/pagination/Pagination';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import DatePicker from '~c/DatePicker';

import searchModelPopup from '~vb/faq/popup/searchModelPopup';
import ExcelDownloadPopup from '~vb/common/ExcelDownloadPopup';

require('moment-jdateformatparser');

export default {
    name: 'qnaStatusList',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': SDLPagination,
    },
    data() {
        return {
            pageName: 'qnaStatusList',
            pageTitle: '',
            categoryDisabled: false,
            modelCd: '',
            modelNm: '',
            modelCheck: true,
            inquiry1Code: '',
            inquiry2Code: '',
            inquiry1CodeList: [],
            inquiry2CodeList: [],
            category1Code: '',
            category2Code: '',
            category3Code: '',
            category1CodeList: [],
            category2CodeList: [],
            category3CodeList: [],
            rhqCode: '',
            rhqCodeList: [],
            subsidiary: '',
            subsidiaryList: [],
            gbm_cd: '',
            gbmCdList: [],
            kpi_charge: '',
            kpiChargeList: [],
            searchRegDeptLevelCd: '',
            searchRegDeptLevelList: [],
            searchStatus: '',
            searchStatusList: [],
            searchFrAddDt: '',
            searchToAddDt: '',
            questionId: '',
            searchDelayPeriod: '',
            totalCount: 0,
            currentPage: 1,
            nRecordsPerPage: Number(localStorage.getItem('listRows')),
            gridKey: 0,
            gridId: this.$route.name + 'Grid',
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.QID.NEW'),
                    name: 'QUESTION_ID',
                    align: 'center',
                    width: 125,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.LEVEL'),
                    name: 'DEPT_LEVEL_CD',
                    align: 'center',
                    width: 75,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.DEPARTMENT'),
                    name: 'DEPARTMENT_NM',
                    align: 'center',
                    width: 125,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY1'),
                    name: 'PRD_CATEGORY_NM1',
                    align: 'center',
                    width: 200,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY2'),
                    name: 'PRD_CATEGORY_NM2',
                    align: 'center',
                    width: 200,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY3'),
                    name: 'PRD_CATEGORY_NM3',
                    align: 'center',
                    width: 200,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY1'),
                    name: 'INQUIRY_TYPE_NM1',
                    align: 'center',
                    width: 200,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY2'),
                    name: 'INQUIRY_TYPE_NM2',
                    align: 'center',
                    width: 200,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBJECT'),
                    name: 'TITLE',
                    align: 'center',
                    width: 375,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.STATUS'),
                    name: 'STATUS_NM',
                    align: 'center',
                    width: 175,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.ADDED.BY'),
                    name: 'REG_USER_NO',
                    align: 'center',
                    width: 100,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.NAME'),
                    name: 'REG_USER_NM',
                    align: 'center',
                    width: 275,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.ADDED.ON'),
                    name: 'REG_DT',
                    align: 'center',
                    width: 125,
                    resizable: true,
                    sortable: false,
                },
            ],
            gridData: [],
            options: {
                scrollY: true,
                scrollX: true,
                minBodyHeight: 80,
                bodyHeight: 450,
            },
        };
    },
    mounted() {
        let toDate = new Date();
        let frDate = new Date();
        frDate.setDate(frDate.getDate() - 7);

        // this.searchFrAddDt = DatePicker.create('fr-picker-container', 'frDate', 'icoFrDate', 'en', {}, frDate);
        // this.searchToAddDt = DatePicker.create('to-picker-container', 'toDate', 'icoToDate', 'en', {}, toDate);
        // 범위 지정 Datepicker 로 변경
        this.rangePicker = DatePicker.createRangeWithOpener(
            'fr-picker-container',
            'frDate',
            'icoFrDate',
            'to-picker-container',
            'toDate',
            'icoToDate',
            { type: 'date', locale: 'en', showToday: false },
            frDate,
            toDate,
        );

        this.categoryList(1);
        this.categoryList(4);
        this.categoryList(6);
        this.categoryList(7);
        this.inquiryList(1);
        this.inquiryList(3);
        this.inquiryList(4);

        setTimeout(() => {
            this.onSearch(1);
        }, 1000);
    },
    computed: {
        ...mapGetters({
            corpCd: 'getCorpCd',
            deptLevelCd: 'getDeptLevelCd',
            curLoginNo: 'getLoginNo',
            roles: 'getRoles',
            menus: 'getMenus',
            corpCd: 'getCorpCd',
        }),
        getReturnPage() {
            let page = 'Admin';
            return page;
        },
    },
    methods: {
        async onSearch(v) {
            let mFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            let startDate = this.rangePicker.getStartDate();
            let endDate = this.rangePicker.getEndDate();
            let searchFromDt = startDate ? moment(startDate).formatWithJDF(mFormat) : '';
            let searchToDt = endDate ? moment(endDate).formatWithJDF(mFormat) : '';
            
            if (parseInt((endDate - startDate) / (24 * 60 * 60 * 1000)) > 7) {
                SDLUtil.alert({
                    title: 'Alert',
                    msg: 'The maximum duration of the search is one week.',
				});
                return false;
            }

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/qnaStatus/qnaStatusSearch.skp`,
                    qs.stringify({
                        page: v,
                        searchInfo: 'set',
                        searchRegRhqNo: this.rhqCode,
                        searchRegCorpNo: this.subsidiary,
                        searchRegDeptNo: this.gbm_cd,
                        searchRegDeptLevelCd: this.searchRegDeptLevelCd,
                        questionId: this.questionId,
                        modelCd: this.modelCd,
                        enqNo: '',
                        searchInquiryType1: this.inquiry1Code,
                        searchInquiryType2: this.inquiry2Code,
                        kpi_charge: this.kpi_charge,
                        searchCategoryA: this.category1Code,
                        searchCategoryB: this.category2Code,
                        searchCategoryC: this.category3Code,
                        searchDelayPeriod: this.searchDelayPeriod,
                        searchStatus: this.searchStatus,
                        searchFromAddDt: searchFromDt,
                        searchToAddDt: searchToDt,
                    }),
                )
                .then(resp => {
                    this.gridData = resp.data.result.rowData;
                    this.totalCount = resp.data.search.totalRecords;
                    this.currentPage = Number(resp.data.search.page);
                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        onExcel(v) {
            let mFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            let startDate = this.rangePicker.getStartDate();
            let endDate = this.rangePicker.getEndDate();
            let searchFromDt = startDate ? moment(startDate).formatWithJDF(mFormat) : '';
            let searchToDt = endDate ? moment(endDate).formatWithJDF(mFormat) : '';

            let url = `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/qnaStatus/qnAStatusExcel.skp`;
            if ('ANSWER' === v) {
                url = `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/qnaStatus/qnAStatusAnswerExcel.skp`;
            }
            SDLUtil.confirm({
                msg: 'Do you want to download the Excel file?<br>Data will be download up to 1000 lines.',
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            url,
                            qs.stringify({
                                searchInfo: 'set',
                                searchRegRhqNo: this.rhqCode,
                                searchRegCorpNo: this.subsidiary,
                                searchRegDeptNo: this.gbm_cd,
                                searchRegDeptLevelCd: this.searchRegDeptLevelCd,
                                questionId: this.questionId,
                                modelCd: this.modelCd,
                                enqNo: '',
                                searchInquiryType1: this.inquiry1Code,
                                searchInquiryType2: this.inquiry2Code,
                                kpi_charge: this.kpi_charge,
                                searchCategoryA: this.category1Code,
                                searchCategoryB: this.category2Code,
                                searchCategoryC: this.category3Code,
                                searchDelayPeriod: this.searchDelayPeriod,
                                searchStatus: this.searchStatus,
                                searchFromAddDt: searchFromDt,
                                searchToAddDt: searchToDt,
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        async inquiryList(v) {
            let type = 'inquiryType' + v;
            if (v === 3) {
                type = 'kpi_charge';
            } else if (v === 4) {
                type = 'gbm_cd';
            }
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/common/inquiryItem/inquiryItemList.skp`,
                    qs.stringify({
                        type: type,
                        useyn: 'Y',
                        deptLevelCd: this.deptLevelCd,
                        deptNo: this.corpCd,
                        value: this.inquiry1Code,
                    }),
                )
                .then(resp => {
                    if (v === 1) {
                        this.inquiry1Code = '';
                        this.inquiry1CodeList = resp.data.result.rowData;
                        this.inquiryList(2);
                    } else if (v === 2) {
                        this.inquiry2Code = '';
                        this.inquiry2CodeList = resp.data.result.rowData;
                    } else if (v === 3) {
                        this.kpiChargeList = resp.data.result.rowData;
                    } else if (v === 4) {
                        this.gbmCdList = resp.data.result.rowData;
                    }
                });
        },
        async categoryList(v) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 1) {
                codeCategoryId = 'ADM_CATEGORY_A';
                parentCode = '0';
                this.category1Code = '';
                this.category2Code = '';
                this.category3Code = '';
                this.category1CodeList = [];
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.corpCd).then(resp => {
                    this.category1CodeList = resp;
                });
            } else if (v === 2) {
                codeCategoryId = 'ADM_CATEGORY_B';
                parentCode = this.category1Code;
                this.category2Code = '';
                this.category3Code = '';
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.corpCd).then(resp => {
                    this.category2CodeList = resp;
                });
            } else if (v === 3) {
                codeCategoryId = 'ADM_CATEGORY_C';
                parentCode = this.category2Code;
                this.category3Code = '';
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.corpCd).then(resp => {
	                for (const category of resp) {
	                	this.category3CodeList.push(category);
	                }
                });
            } else if (v === 4) {
                codeCategoryId = 'RHQ_DATA_ACCESS_CD';
                parentCode = 'organizationRoot';
                this.rhqCode = '';
                this.rhqCodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.curLoginNo).then(resp => {
                    this.rhqCodeList = resp;
                    this.rhqCode = resp[0].code;
                    this.categoryList(5);
                });
            } else if (v === 5) {
                codeCategoryId = 'SUB_DATA_ACCESS_CD';
                parentCode = this.rhqCode;
                this.subsidiary = '';
                this.subsidiaryList = [];
                if (!SDLUtil.isNull(parentCode)) {
                    await this.getCodeComboList(parentCode, codeCategoryId, this.curLoginNo).then(resp => {
                        this.subsidiaryList = resp;
                        this.subsidiary = resp[0].code;
                    });
                }
            } else if (v === 6) {
                codeCategoryId = 'DEPT_LEVEL_CD';
                this.searchRegDeptLevelCd = this.deptLevelCd;
                this.searchRegDeptLevelList = [];
                await this.getCommonCodeList(codeCategoryId).then(resp => {
                    this.searchRegDeptLevelList = resp;
                });
            } else if (v === 7) {
                codeCategoryId = 'QNA_STATUS';
                this.searchStatus = '';
                this.searchStatusList = [];
                await this.getCommonCodeList(codeCategoryId).then(resp => {
                    this.searchStatusList = resp;
                });
            }
        },
        async getCodeComboList(categoryVal, categoryCode, addCondition) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, addCondition);
            return codeResp;
        },
        async getCommonCodeList(codeCategoryId) {
            const codeResp = await api.getCommonCodeList(codeCategoryId);
            return codeResp;
        },
        searchModelPopup() {
            let searchModel = this.modelNm;
            SDLUtil.show(
                searchModelPopup,
                {
                    searchModel,
                    rtnFunc: (arg1, arg2, arg3, arg4, arg5) => {
                        this.applyModel(arg1, arg2, arg3, arg4, arg5);
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        applyModel(arg1, arg2, arg3, arg4, arg5) {
            this.modelCd = arg1;
            this.modelNm = arg2;
            this.modelCheck = false;
        },
        contentClick(e, rowData, grid) {
            return this.$router.push({
                path: this.menuCommit('Q&A', 'Answer Question', '/skp/basis/myKnowledge/myQnA/toAnswer/answerDetail'),
                query: { questionId: SDLUtil.nvl(rowData[e.rowKey]['QUESTION_ID']), page: 'Admin' },
            });
        },
        menuCommit(menu, subMenu, connUrl) {
            for (const menus of this.menus) {
                if (menu === menus.menuNm) {
                    for (const menu of menus.subMenu) {
                        if (subMenu === menu.menuNm) {
                            store.commit('PARAMS', { menuId: menu.menuId, creationYn: menu.creationYn });
                            if (SDLUtil.isNull(connUrl)) {
                                connUrl = menu.connUrl.replace('.skp', '');
                            }
                            return connUrl;
                        }
                    }
                }
            }
            if ('Admin' === this.getReturnPage) {
                return connUrl;
            }
        },
    },
};
</script>


<style>
.tui-datepicker {
    z-index: 9999;
    border: 1px solid #aaa;
    background-color: white;
    position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/qnaManager/qnaStatusList.vue